import queryString from "query-string";
import {
  GetDate,
  GetIdsList,
  GetImprestStateList,
  GetSortField,
  GetSortType,
  GetTextSearch,
  GetUseHasAppendix
} from "../../../../../assets/convertUrlFilter";
import { OVERALL_COST_DETAIL } from "../../../../../constants/sectionTypes";
import {
  ADD_APPENDIX,
  ALL_IMPREST_STATES_ARRAY,
  APPENDIX,
  END_DATE,
  FILE_TYPE,
  IMPREST_IDS,
  IMPREST_STATES,
  IMPREST_STATES_FOR_OTHER_REPORTS,
  SORT_FIELD,
  SORT_TYPE,
  START_DATE,
  TEAM_IDS,
  TEXT_SEARCH,
  USER_IDS
} from "../../../../../constants/filters";
import { FILE_TYPES } from "../../../../../constants/file";

export default () => {
  let filters = queryString.parse(document.location.search);
  return filtersNormalize(filters);
};

const filtersNormalize = filters => {
  return {
    [FILE_TYPE]: FILE_TYPES.WEB,
    [IMPREST_IDS]: GetIdsList(filters[IMPREST_IDS]),
    [START_DATE]: GetDate(filters[START_DATE]),
    [END_DATE]: GetDate(filters[END_DATE]),
    [APPENDIX]: GetUseHasAppendix(filters[APPENDIX]),
    [ADD_APPENDIX]: filters[ADD_APPENDIX] ? filters[ADD_APPENDIX] : false,
    [SORT_FIELD]: GetSortField(filters[SORT_FIELD], OVERALL_COST_DETAIL),
    [SORT_TYPE]: GetSortType(filters[SORT_TYPE]),
    [TEXT_SEARCH]: GetTextSearch(filters[TEXT_SEARCH]),
    [USER_IDS]: GetIdsList(filters[USER_IDS]),
    [TEAM_IDS]: GetIdsList(filters[TEAM_IDS]),
    [IMPREST_STATES_FOR_OTHER_REPORTS]: GetImprestStateList(
        filters[IMPREST_STATES],
        ALL_IMPREST_STATES_ARRAY
    )
  };
};
